import { createUseStyles } from 'react-jss'

import { red } from '../../../../../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  hasError: {
    '& input': {
      borderColor: red
    }
  }
})

export default useStyles
